<template>
    <div>
        <button
            type="button"
            :class="`btn-${dangerButtonSize} ${buttonClasses}`"
            class="btn"
            @click="$modal.show(modalName)"
        >
            <slot />
        </button>

        <form-modal
            :name="modalName"
            :primary-button-text="primaryButtonText"
            primary-button-class="is-danger"
            :title="title"
            :redirect-to="redirectTo"
            :method="method"
            :action="action"
        >
            <slot name="modal-content" />
        </form-modal>
    </div>
</template>
<script>
    export default {
        props: {
            modalName: {
                required: true,
                type: String,
            },
            dangerButtonSize: {
                required: false,
                type: String,
                default: 'md',
                validator(value) {
                    return ['sm', 'md', 'lg'].indexOf(value) !== -1;
                },
            },
            action: {
                required: true,
                type: String,
            },
            method: {
                required: false,
                type: String,
                validator(value) {
                    return ['post', 'patch', 'delete'].indexOf(value) !== -1;
                },
                default: 'delete',
            },
            redirectTo: {
                required: true,
                type: String,
            },
            title: {
                required: true,
                type: String,
            },
            primaryButtonText: {
                required: true,
                type: String,
            },
            isGhost: {
                required: false,
                type: Boolean,
                default: false,
            },
            whiteBorder: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            buttonClasses() {
                let buttonClasses = 'is-danger';

                if (this.whiteBorder) {
                    buttonClasses += ' border-xs border-white';
                }

                if (this.isGhost) {
                    buttonClasses += ' is-ghost';
                }

                return buttonClasses;
            },
        },
    };
</script>